module.exports = __webpack_public_path__ + "img/hr-garballo-15.3c7bfc36.png";